<p-confirmDialog></p-confirmDialog>

<!-- 		 	     -->
<!-- Person Selector -->
<!-- 			 	 -->
<div>
	<caass-personselector
		[AudienceID]="1"
		[CanSwitchAudience]="false"
		[ShowAllSchools]="true"
		[MultiSelect]="false"
		[buttonMultiSelectProcessCaption]="'Add'"
	></caass-personselector>
</div>

<!--                      -->
<!-- Set Student Language -->
<!--                      -->
<div class="LanguageDiv" *ngIf="IsNotificationsForSchoolEnabled == true">
	<div class="LanguageGrid">
		<label class="NoMargin">Notify Language:</label>

		<select [disabled]="isBusy == true" class="form-control NoMargin" name="SelectedNotifyLanguageID" [(ngModel)]="SelectedNotifyLanguageID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstNotifyLanguages" [ngValue]="o.NotifyLanguageID">
				{{ o.NotifyLanguageDesc }}
			</option>
		</select>

		<button [disabled]="isBusy == true" class="btn btn-primary" (click)="onUpdateLanguage()">Update Language</button>
	</div>
</div>

<!-- 		 	       -->
<!-- Registration Info -->
<!-- 			 	   -->
<div style="display: flex; justify-content: center; background-color: #eeeeee; margin-bottom: 25px; padding-top: 10px; padding-bottom: 10px; font-size: 18px">
	<div style="width: 275px">
		<div style="display: flex; flex-direction: row">
			<p align="right" style="width: 145px">Registration Key:</p>
			<p></p>

			<div style="margin-left: 10px; font-weight: bold">
				<p>{{ GuardianNotification.Response?.RegistrationNbr }}</p>
			</div>
		</div>

		<div style="display: flex; flex-direction: row">
			<p align="right" style="width: 145px">Expiry Date:</p>
			<p></p>

			<div style="margin-left: 10px; font-weight: bold">
				<p>
					{{ GuardianNotification.Response?.RegistrationExpireDT | date : "MM/dd/yyyy" }}
				</p>
			</div>
		</div>

		<div style="display: flex; justify-content: center; width: 275px">
			<button
				class="btn btn-primary"
				role="button"
				(click)="CreateRegistration()"
				[disabled]="isBusy == true || IsNotificationsForSchoolEnabled == false"
			>
				{{ isKeyGenerated == false ? "Generate Key" : "Reset Date" }}
			</button>
			<button
				style="margin-left: 10px"
				*ngIf="isKeyGenerated == true"
				class="btn btn-primary"
				role="button"
				(click)="CreateRegistrationReset()"
				[disabled]="isBusy == true || IsNotificationsForSchoolEnabled == false"
			>
				Create New Activation Key
			</button>
		</div>
	</div>
</div>

<!-- 		 	-->
<!-- Email Info -->
<!-- 			-->
<div>
	<table class="table table-striped table-bordered table-hover" my-table options="options" width="100%" id="myGuardianListTable">
		<thead>
			<tr>
				<th>Name</th>
				<th>e-mail</th>
				<th></th>
			</tr>
		</thead>

		<tbody>
			<tr *ngFor="let guardian of GuardianList; let i = index">
				<td>
					<p *ngIf="guardian.IsImport" class="form-control-static">
						{{ guardian.Name }}
					</p>
					<input
						placeholder="Enter Guardian Name"
						type="text"
						name="Name"
						*ngIf="!guardian.IsImport"
						class="form-control"
						[(ngModel)]="guardian.Name"
					/>
				</td>

				<td>
					<input type="text" placeholder="Enter Guardian Email" name="Email{{ i }}" class="form-control" [(ngModel)]="guardian.Email" />
				</td>

				<td>
					<div>
						<p
							style="margin-top: 2px"
							*ngIf="guardian.Email"
							href="javascript:void(0);"
							class="btn btn-danger btn-xs"
							data-toggle="tooltip"
							data-placement="top"
							title="Remove"
							(click)="removeGuardian(i)"
						>
							<i class="fa fa-times"></i>Remove
						</p>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 15px">
	<button class="btn btn-primary" role="button" (click)="addGuardian()" [disabled]="isBusy == true || IsNotificationsForSchoolEnabled == false">
		Add e-mail
	</button>
	<button class="btn btn-primary" role="button" (click)="sendEmail()" [disabled]="isBusy == true || IsNotificationsForSchoolEnabled == false">
		Send e-Email
	</button>
</div>

<!-- 		 -->
<!-- Message -->
<!-- 		 -->
<div style="margin-top: 10px">
	<div id="NotificationDisabledMessage" *ngIf="NotificationDisabledMessage" class="alert alert-warning">
		{{ NotificationDisabledMessage }}
	</div>
	<div id="SaveErrorMessage" *ngIf="SaveErrorMessage" class="alert alert-danger">
		{{ SaveErrorMessage }}
	</div>
	<div id="SuccessMessage" *ngIf="SuccessMessage" class="alert alert-success">
		{{ SuccessMessage }}
	</div>
	<div id="SaveDone" *ngIf="SaveDone" class="alert alert-success">Key successfully sent</div>
</div>
